import { render, staticRenderFns } from "./imgremoval.vue?vue&type=template&id=5a16a087&scoped=true"
import script from "./imgremoval.vue?vue&type=script&lang=js"
export * from "./imgremoval.vue?vue&type=script&lang=js"
import style0 from "./imgremoval.vue?vue&type=style&index=0&id=5a16a087&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16a087",
  null
  
)

export default component.exports